<template lang="pug">
  article.videoitem(:class="position")
    .col
      h2(v-html="post.title.rendered")
      .excerpt(v-html="post.excerpt.rendered")
    .col
      .video
        .iframewrapper(v-html="post.content.rendered")


</template>
<script>
export default {
  props: {
    post: Object,
    position: String
  },
}
</script>
<style lang="scss" scoped>
  .videoitem{
    position: relative;
    display: grid;
    grid-template-columns: 2fr 3fr;
    align-items: center;
    grid-gap: $globalgapping;
    margin-bottom: 1rem;
    padding: $globalpadding;
    @media (max-width: 800px){
      grid-template-columns: 1fr;
      padding: 1rem;
      .col{
        &:first-of-type{
          order: 2;
        }
      }
    }
    &.even{
      background-color: black;
      color: white;
      grid-template-columns: 3fr 2fr;
      @media (max-width: 800px){
        grid-template-columns: 1fr;
      }
      .col{
        &:first-of-type{
          order: 2;
        }
      }
    }
  }
  .iframewrapper{
    position: relative;
    padding-top: 56.25%;
    padding-bottom: 0;
    height: 0;
    width: 100%;
    /deep/ iframe{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  h2 {
    &::after{
      content: '';
      display: block;
      width: 60%;
      height: 20px;
      background-color: orange;
      margin-top: $globalgappingx / 4;
      margin-bottom: $globalgappingx / 4;
    }
  }

</style>

